import { ZHLPersonalizedNextStepState } from 'src/services/graphql/generated/graphql';

export enum UpsellCTAVariant {
    NEW_APPLICATION = 'NEW_APPLICATION',
    FIRST_PARTY_NEW_APPLICATION = 'FIRST_PARTY_NEW_APPLICATION',
    OUTSTANDING_TASKS = 'OUTSTANDING_TASKS',
    FIRST_PARTY_OUTSTANDING_TASKS = 'FIRST_PARTY_OUTSTANDING_TASKS',
    VERIFIED_PREAPPROVAL = 'VERIFIED_PREAPPROVAL',
    FIRST_PARTY_VERIFIED_PREAPPROVAL = 'FIRST_PARTY_VERIFIED_PREAPPROVAL',
    FIRST_PARTY_VERIFIED_PREAPPROVAL_NO_TRID_OUTSTANDING_TASKS = 'FIRST_PARTY_VERIFIED_PREAPPROVAL_NO_TRID_OUTSTANDING_TASKS',
    WAITING_TO_CLOSE = 'WAITING_TO_CLOSE',
    FIRST_PARTY_WAITING_TO_CLOSE = 'FIRST_PARTY_WAITING_TO_CLOSE',
}

export const toUpsellCTAVariant = (
    status: ZHLPersonalizedNextStepState | undefined,
    isFirstPartyExperience: boolean
) => {
    switch (status) {
        case ZHLPersonalizedNextStepState.NEW_APPLICATION:
            return isFirstPartyExperience
                ? UpsellCTAVariant.FIRST_PARTY_NEW_APPLICATION
                : UpsellCTAVariant.NEW_APPLICATION;
        case ZHLPersonalizedNextStepState.VERIFIED_PREAPPROVAL_NO_TRID_OUTSTANDING_TASKS:
            return UpsellCTAVariant.FIRST_PARTY_VERIFIED_PREAPPROVAL_NO_TRID_OUTSTANDING_TASKS;
        case ZHLPersonalizedNextStepState.OUTSTANDING_TASKS:
            return isFirstPartyExperience
                ? UpsellCTAVariant.FIRST_PARTY_OUTSTANDING_TASKS
                : UpsellCTAVariant.OUTSTANDING_TASKS;
        case ZHLPersonalizedNextStepState.VERIFIED_PREAPPROVAL:
            return isFirstPartyExperience
                ? UpsellCTAVariant.FIRST_PARTY_VERIFIED_PREAPPROVAL
                : UpsellCTAVariant.VERIFIED_PREAPPROVAL;
        case ZHLPersonalizedNextStepState.WAITING_TO_CLOSE:
            return isFirstPartyExperience
                ? UpsellCTAVariant.FIRST_PARTY_WAITING_TO_CLOSE
                : UpsellCTAVariant.WAITING_TO_CLOSE;
        default:
            return null;
    }
};
